import React from 'react'
import { AlertTriangleIcon, ChevronLeftIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '../ui/button'
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '../ui/empty'
import { ModalBody, ModalClose, ModalFooter } from '../ui/modal'
import { useImportFromFile } from './ImportFromFileProvider'

function ImportFromFileErrors({ children }: { children: React.ReactNode }) {
	const { t } = useTranslation()

	const context = useImportFromFile()

	return (
		<>
			<ModalBody className='relative flex flex-col overflow-hidden'>
				<Empty>
					<EmptyHeader>
						<EmptyMedia variant='icon' className='bg-destructive/20'>
							<AlertTriangleIcon className='text-destructive' />
						</EmptyMedia>
						<EmptyTitle>{t('og_bulk_import_error')}</EmptyTitle>
						<EmptyDescription>{t('og_bulk_import_canceled')}</EmptyDescription>
					</EmptyHeader>
					<EmptyContent className='text-left'>{children}</EmptyContent>
				</Empty>
			</ModalBody>
			<ModalFooter className='justify-start'>
				<ModalClose asChild className='mr-auto'>
					<Button>{t('general_cancel')}</Button>
				</ModalClose>
				<Button onClick={() => context.setStep('form')}>
					<ChevronLeftIcon />
					{t('general_back')}
				</Button>
			</ModalFooter>
		</>
	)
}
export { ImportFromFileErrors }
